import { useContext } from 'react';
import { AppContext, AppContextInterface } from '../modules/core/contexts/AppContext';

// todo - refactor to remove this.  Just use useContext(AppContext).
export const useAppContext = (): AppContextInterface => {
  return useContext(AppContext);
};
